import {call, put, takeLatest} from "redux-saga/effects";
import {httpRequestsOnErrorsActions} from "../http_requests_on_errors";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {httpRequestsOnSuccessActions} from "../http_requests_on_success";
import { CHANGE_BATCH_STATUS_APPROVE, CHANGE_BATCH_STATUS_UNPAID } from './batch.types';
import { batchService } from './batch.service';

/** Batch */

function* changeBatchStatusToApprove(action) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        yield call(batchService.changeBatchStatusApprove, action?.payload?.id);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* changeBatchStatusToUnPaid(action) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        yield call(batchService.changeBatchStatusUnpaid, action?.payload?.id);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err.data.message));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}


/** End */


export const watchBatch = function* watchBatchSaga() {
    /** Batch */
    yield takeLatest(CHANGE_BATCH_STATUS_APPROVE, changeBatchStatusToApprove);
    yield takeLatest(CHANGE_BATCH_STATUS_UNPAID, changeBatchStatusToUnPaid);
    /** End */
};
